import React from 'react'
import PropTypes from 'prop-types'
import ExploreCarousels from './ExploreCarousels'
import { connect } from 'react-redux'
import { insertPlanCategories } from '../../../../redux/actions/planCategories'
import { setFeaturedProducts } from '../../../../redux/actions/featuredProduct'
import { featuredProducts } from '../../../../redux/selectors/featuredProducts'
import FeaturedProductsCarousel from '../../../featuredProducts/FeaturedProductsCarousel'
import CategoryFilters from '../exploreNav/CategoryFilters'
import FilterMetaLayout from '../../../filtersRow/FilterMetaLayout'
import GreyPageHeader from '../../../GreyPageHeader'
import { pageTitle, pageCaption } from '../ExploreHeaders'

import './ExploreCarousels.scss'

class ExploreCarouselPage extends React.Component {
  constructor (props) {
    super(props)

    props.setupCategories()
    props.setFeaturedProducts()

    this.buildSeriesPageFilterOptions = this.buildSeriesPageFilterOptions.bind(
      this
    )

    this.state = {
      loaded: false
    }
  }

  componentDidMount () {
    window.onload = () => {
      this.setState({ loaded: true })
    }
  }

  buildSeriesPageFilterOptions () {
    let filterObj = {}
    this.props.categories.forEach(category => {
      filterObj[category.title] = {
        onClickFilterDropdown: value => {
          window.location.href = `${
            this.props.baseUrl
          }/filter?categories=${value}`
        },
        hasDropdown: false,
        filterValue: category.slug
      }
    })
    return filterObj
  }

  render () {
    const filterOptions = this.buildSeriesPageFilterOptions()

    return (
      <div className='ExploreCarouselsPage'>
        <GreyPageHeader title={pageTitle} caption={pageCaption} />
        <FilterMetaLayout
          filters={filterOptions}
          totalProducts={this.props.allProductCount}
          sortableFields={['rank', 'az', 'date']}
          order={'rank'}
          contentLabel='Series'
          noLowerXs
          renderTopRow={() => (
            <CategoryFilters
              filterOptions={filterOptions}
              categories={this.props.categories}
              uniButtonSelect={value => {
                window.location.href = `${
                  this.props.baseUrl
                }/filter?categories=${value}`
              }}
            />
          )}
          onSort={order => {
            window.location.href = `${this.props.baseUrl}/filter?order=${order}`
          }}
        />
        <div className='hidden-xs'>
          <FeaturedProductsCarousel
            featuredProducts={this.props.featuredProducts}
          />
        </div>
        <ExploreCarousels loaded={this.state.loaded} />
        <div className='btn-wrapper-container center-button see-all-button'>
          <a href={`${this.props.baseUrl}/filter`} className='btn alo-button'>
            See all styles
          </a>
        </div>
      </div>
    )
  }
}

ExploreCarouselPage.propTypes = {
  allProductCount: PropTypes.number,
  categories: PropTypes.array,
  featuredProducts: PropTypes.array,
  setupCategories: PropTypes.func,
  setFeaturedProducts: PropTypes.func,
  baseUrl: PropTypes.string
}

const mapStateToProps = state => {
  return {
    featuredProducts: featuredProducts(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setupCategories: () => {
      dispatch(insertPlanCategories(ownProps.categories, true))
    },
    setFeaturedProducts: () => {
      dispatch(setFeaturedProducts(ownProps.featuredProducts))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExploreCarouselPage)
